export const NORMALIZE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DEFAULT_FORMAT = 'YYYY-MM-DD HH:mm';
